import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Text } from '../../../../common/text/Text';
import { Lozenge } from '../../../../common/lozenge/Lozenge';
import { retrieveStatusString } from '../../../../casescontext/adapters/primary/listcases/tableutils';

const ELIGIBLE_STATUSES = [2, 7];

export const createHeadTableSaisine = (isOpen) => ({
  cells: [
    {
      key: 'claim',
      content: 'Dossier',
      shouldTruncate: true,
      isSortable: true,
      width: 24,
    },
    {
      key: 'flightdate',
      content: 'Vol',
      shouldTruncate: true,
      isSortable: true,
      width: 18,
    },
    {
      key: 'passengers',
      content: 'Pax',
      shouldTruncate: true,
      isSortable: false,
      width: 16,
    },
    {
      key: 'amount',
      content: 'Indemnité',
      shouldTruncate: true,
      isSortable: true,
      width: 12,
    },
    {
      key: 'status',
      content: 'Statut',
      shouldTruncate: true,
      isSortable: false,
      width: isOpen ? 24 : 34,
    },
    ...(isOpen ? [{
      key: 'remove',
      content: 'Retirer',
      shouldTruncate: false,
      isSortable: false,
      width: 10,
    }] : []),
  ],
});

export const createRowsTableSaisine = (saisine, remove) => {
  const isOpen = saisine.status !== 'SENT';

  return saisine.claims.map(({ claim, generationReady }) => {
    const statusEligible = ELIGIBLE_STATUSES.includes(Number(claim.status));
    const statusLabel = retrieveStatusString(claim.status) || `Statut ${claim.status}`;
    const nbPax = claim.passengers.filter((passenger) => passenger.active !== false).length;

    return {
      key: claim._id,
      cells: [
        {
          key: `claim-${claim._id}`,
          content: (
            <Link to={{ pathname: '/dossier', search: `?id=${claim._id}&from=saisine&saisineId=${saisine._id}` }}>
              <p>{`${claim.from_id} — ${claim.fullNameMainPassenger()}`}</p>
            </Link>
          ),
        },
        {
          key: `date-${claim._id}`,
          content: (
            <Text color="secondary" variant="body2">
              {`${claim.flight_date ? format(new Date(claim.flight_date), 'dd/MM/yyyy') : '—'} · ${claim.airport_departure || '?'} → ${claim.airport_arrival || '?'}`}
            </Text>
          ),
        },
        {
          key: `pax-${claim._id}`,
          content: generationReady
            ? <Lozenge text={`${nbPax} pax complets`} green />
            : <Lozenge text={`${nbPax} pax incomplets`} red />,
        },
        {
          key: `amount-${claim._id}`,
          content: (
            <Text color="secondary" variant="body2">
              {`${(claim.compensation_total || 0).toLocaleString('fr-FR')} €`}
            </Text>
          ),
        },
        {
          key: `status-${claim._id}`,
          content: statusEligible || !isOpen
            ? <Lozenge text={statusLabel} blue />
            : <Lozenge text={statusLabel} red />,
        },
        ...(isOpen ? [{
          key: `remove-${claim._id}`,
          content: (
            <IconButton
              size="small"
              aria-label="Retirer le dossier de la saisine"
              onClick={() => remove(claim._id)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ),
        }] : []),
      ],
    };
  });
};
